
CheckoutV2.Suggestions = function(checkout) {
    var suggestions = this;

    suggestions.items = {};
    suggestions.products = [];
    suggestions.$modal = false;
    suggestions.$suggestionContainer = false;
    suggestions.addedToModal = false;

    suggestions.init = function() {
        suggestions.$modal = $(".product-suggestions.modal");
        suggestions.$suggestionContainer = suggestions.$modal.find('.suggestion-container');
        suggestions.listen();
    };

    suggestions.listen = function() {
                
        $('.product-suggestions.modal').on('shown.bs.modal', function() {
			//suggestions.$modal.find('.modal-body').css({'max-height':'100%'});
            suggestions.equalHeight();
		});
        
        checkout.cart.$showSuggestions.click(suggestions.show);
    };

    // Prepare and display the modal dialog with the suggestions
    suggestions.show = function() {
        // Only show the suggestions if there are some to show
        if(! Object.keys(suggestions.items).length) return;

        // If we've seen all of the items, don't popover
        if(suggestions.addToModal() && !suggestions.seenStatus(seenSuggestions)) {
           	// Only show the dialog if we added something to it            
           	suggestions.$modal.modal("show");            
        }
    };

	suggestions.seenStatus = function(hasSeen) {
		// If we've already 'seen' the modal, set false to allow us to click it
		if(hasSeen) {
			return false;
		}

		// Check the seen status of all parts, if we've seen all of them then don't load on loading of the cart
		var seen = 0;
		for ( var suggestion in suggestions.items ) {
			if ( suggestions.items[suggestion].seen === 1 ) {
				seen++;
			}
		}

		if ( seen === Object.keys(suggestions.items).length ) {
			return true;
		}
	};

    // Add the current list of products to the modal window
    suggestions.addToModal = function() {
        // Only add items once
        if(suggestions.addedToModal) return true;

        var validSuggestions = 0;
        for(var productID in suggestions.items) {
            if(suggestions.addProductToModal(suggestions.items[productID])) validSuggestions ++;
        }

        if(validSuggestions) {
            checkout.cart.$showSuggestions.find(".suggestionCount").html(validSuggestions);
            checkout.cart.$showSuggestions.removeClass("hide");
        }
        else {
            return false;
        }

        suggestions.addSectionsToModal();
        suggestions.addedToModal = true;
        return true;
    };

    // Build product html and add to modal
    suggestions.addProductToModal = function(item) {
        var product = item.product;
        
        var $product = $($.parseHTML(Jemplate.process('includes/partials/suggestedProduct.html', {
            product: product,
            CDNstatic: CDNpath,
            CDNproduct: CDNproduct,
        }))); 
        
        // Do not suggest items already seen
        if (item.seen)
            return false;

        // Do not suggest something already in the cart
        if(checkout.cart.containsProductID(product.productID))
            return false;
        
        // set pricing detail
        var discount = 0;

        if (product.price_retail) {
            discount = (product.price_retail - product.unitprice) / product.price_retail;
        }

        if(discount > 0.01) {
            var $onSale = $product.find(".on-sale span");
            var $priceCut = $product.find(".pricing .price-cut");
            var $priceSave  = $product.find(".pricing .price-save");
            var $priceDivider  = $product.find(".pricing .divider");            
            var percent = Math.round(discount * 100);
            
            if (product.availablePricing['limitedQty']) {
                $priceSave.html('LIMITED QTY');
            } else {
                $priceSave.html('SAVE ' + percent + '%');
            }    
            
            if(discount > 0.10) {
                $priceSave.removeClass('hide');            
                $priceDivider.removeClass('hide');                                
            }
            
            $onSale.removeClass('hide');                        
            $priceCut.removeClass('hide');                        
        };
        
        // build ratings
        var rating = parseInt(product.ratingAverage);        
        if (rating) {
            var ratingHalf = parseInt(parseFloat(product.ratingAverage) + 0.5 - rating);
            $product.find('.rating').append('<div class="stars"></div>');
            var starsHtml = $product.find(".rating .stars");
            for (i = 1; i <= 5; i++) { 
                if (i <= rating) {
                    starsHtml.append('<span class="fa fa-star checked"></span>');
                } else if ( i == (rating + 1) && ratingHalf ) {
                    starsHtml.append('<span class="fa fa-star-half-o"></span>');
                } else {
                    starsHtml.append('<span class="fa fa-star-o"></span>');
                }
            }
            starsHtml.append(' <span class="rating-count">(' + product.ratingCount + '<span class="reviews-title"> Reviews</span>)</span>');
        };
        
        // free shipping indicators
        if (parseInt(product.shipfree || 0)) {
			$product.find(".free-shipping .ships-free").removeClass('hide');
		}
        else if (parseInt(product.shipFreeEligible || 0)) {
			$product.find(".free-shipping .ships-free-eligible").removeClass('hide');
		};
        
        // listen and change history button state
        $product.find("button.atc").click(function() {
            if(window.history.replaceState) {
                window.history.replaceState({}, "", "./Suggestion/");
            }
            addToCart(product.productID);
            return false;
        });
        
        // store the product
		suggestions.products.push($product);
        return true;
    };

    // Insert the various sections into the modal dialog
    suggestions.addSectionsToModal = function(){
		for(var i = 0; i < suggestions.products.length; i++){
			suggestions.$suggestionContainer.append(suggestions.products[i]);
      }
    };

    // Add a product to the suggestion list, keyed by productID to prevent duplicates
    suggestions.addItem = function(item) {
        suggestions.items[item.product.productID] = item;
    };
    
    // set equals heights for horizontal alignment for medium breakpoint and up
    suggestions.equalHeight = function() {
        var sections = [
            ".description",
            ".long-description",
            ".rating",
            ".brand-logo",
            ".part-numbers",
            ".stock-status",
            ".on-sale",
            ".pricing",
            ".price-qty",
            ".free-shipping"
        ];

        $.each(sections, function(i, section) {
			var maxHeight = 0;
            var children = $('.suggestion-container').find('.product ' + section);
            $(children).css({'height' : 'inherit'});
            $.each(children, function(i, child) {
                if ( $(child).height() > maxHeight ) {
                    maxHeight = $(child).height();
                }                    
            });            
            $(children).css({'height' : maxHeight + 'px'});
		});        
    }

    suggestions.init();
};

